import { inject, observer } from "mobx-react";
import * as React from "react";

import { ApplicationStore } from "../../../stores/ApplicationStore";
import InputField from "../form-elements/InputField";
import LoadingWidget from "../Loading";
import { errorMessage } from "../Toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHandPaper } from "@fortawesome/free-solid-svg-icons";

interface State {
    loading: boolean;
}

interface PropsComponent {
    label: string;
    fieldName: string;
    required?: boolean;
}

interface PropsStore {
    applicationStore?: ApplicationStore;
}

type Props = PropsComponent & PropsStore;

@inject("applicationStore")
@observer
export default class SimpleInputField extends React.Component<Props, State> {
    state: State = {
        loading: false
    };

    onChangeSimpleField = async (updatedValue: string) => {
        try {
            // Skip on no change
            if (this.props.applicationStore!.findSimpleFieldValue(this.props.fieldName) === updatedValue) {
                return;
            }

            this.setState({ loading: true });
            await this.props.applicationStore!.updateSimpleFields({
                [this.props.fieldName]: updatedValue
            });
        } catch (error) {
            errorMessage(error);
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const simpleFieldValue = this.props.applicationStore!.findSimpleFieldValue(this.props.fieldName) || "";
        return (
            <>
                <div className="w-100-percentage mr-2">
                    <label>
                        {this.props.label}
                        {this.props.required && !simpleFieldValue ? (
                            <div>
                                <span className="badge badge-warning my-2">
                                    <FontAwesomeIcon icon={faHandPaper} />
                                    &nbsp; Please enter a value for this field.
                                </span>
                            </div>
                        ) : null}
                    </label>
                    {this.state.loading && (
                        <span className="ml-3">
                            <LoadingWidget />
                        </span>
                    )}
                </div>
                <InputField
                    fieldName={this.props.fieldName}
                    value={simpleFieldValue}
                    onBlur={this.onChangeSimpleField}
                    disabled={this.state.loading || this.props.applicationStore!.completed}
                />
            </>
        );
    }
}
